import { sagaCreator } from '@adrias-online/steiner';

import helper from '../../../helpers/steinerHelper';
import { actions, actionTypes } from '../actions/portaliArchivioMail';
import { selectors, DEFAULT_STATE } from '../reducers/portaliArchivioMail';
import api from '../apis/portaliArchivioMail';

const sagas = helper.createSagas(
    'portaliArchivioMail',
    actionTypes,
    actions,
    api,
    selectors,
    DEFAULT_STATE,
    {
        numberFilters: ['portaleId']
    }
);

const defaultSagas = sagaCreator.bootSagas(sagas, actionTypes);

export default [...defaultSagas];
